import React, { useEffect } from 'react';
import { LisseaArticle } from './components/LisseaArticle';
export function App() {
  useEffect(() => {
    document.title = 'Lissea';
  }, []);
  return <LisseaArticle data-id="element-0" />;
}